import { Autoplay, Controller, EffectFade, Navigation, Parallax, Pagination, Swiper } from 'swiper'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

Swiper.use([Autoplay, Controller, EffectFade, Navigation, Parallax, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

gsap.registerPlugin(ScrollTrigger)

if (document.getElementById('page-top')) {
  pageTop()
}

function pageTop() {
  /*
 ######  ##      ## #### ########  ######## ########
##       ##  ##  ##  ##  ##     ## ##       ##     ##
 ######  ##  ##  ##  ##  ########  ######   ########
      ## ##  ##  ##  ##  ##        ##       ##   ##
 ######   ###  ###  #### ##        ######## ##     ##
*/
  const swiper01 = new Swiper('.js-slider-01', {
    loop: true,
    speed: 3000,
    effect: 'fade',
    autoplay: {
      delay: 3000,
      disableOnInteraction: true,
    },
    pagination: {
      el: '.topMV__slider-pagination',
      type: 'custom',
      clickable: true,
      renderCustom: function (swiper, current, total) {
        return current + ' <span class="line"></span> ' + total
      },
    },
  })

  const swiper02 = new Swiper('.js-slider-02', {
    loop: true,
    allowTouchMove: false,
    effect: 'fade',
  })

  swiper01.controller.control = swiper02
  swiper02.controller.control = swiper01

  const top_customer = new Swiper('.js_customer', {
    centeredSlides: false,
    slidesPerView: 1.6,
    spaceBetween: 10,
    speed: 6000,
    loop: true,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: true,
    },
    breakpoints: {
      // スライドの表示枚数：768px以上の場合
      768: {
        centeredSlides: false,
        slidesPerView: 2.6,
        spaceBetween: 20,
      },
      // スライドの表示枚数：1180px以上の場合
      1180: {
        centeredSlides: false,
        slidesPerView: 3.4,
        spaceBetween: 10,
      },
    },
  })

  const slideCount = document.querySelectorAll('.js_member .swiper-slide').length
  let memberSwiper = null
  if (slideCount >= 2) {
    // スライダーの初期化
    let memberSwiper = new Swiper('.js_member', {
      centeredSlides: false,
      slidesPerView: 1.2,
      spaceBetween: 20,
      speed: 1000,
      loop: true,
      // autoplay: {
      //   delay: 3000,
      //   disableOnInteraction: true,
      // },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        // スライドの表示枚数：768px以上の場合
        768: {
          centeredSlides: false,
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        // スライドの表示枚数：1180px以上の場合
        1180: {
          centeredSlides: false,
          slidesPerView: 2.2,
          spaceBetween: 30,
        },
      },
    })
  } else {
    // スライダーの解除
    if (memberSwiper) {
      memberSwiper.destroy(false, true)
    }

    // スタイルを元に戻す
    const swiperWrapper = document.querySelector('.js_member .swiper-wrapper')
    if (swiperWrapper) {
      swiperWrapper.style.width = 'auto'
    }
  }

  /*
 ######    ######     ###    ########
##        ##        ##   ##  ##     ##
##   ####  ######  ##     ## ########
##    ##        ## ######### ##
 ######    ######  ##     ## ##
*/
  var o = 'expo.out'
  gsap.fromTo(
    '.intro-head--1',
    { x: '-100%' },
    {
      x: 0,
      duration: 2,
      ease: o,
      scrollTrigger: {
        trigger: '.intro-head',
        start: 'top bottom-=1',
        end: 'bottom top+=1',
        scrub: 1,
        markers: false,
      },
    },
    '+=0'
  )
  gsap.fromTo(
    '.intro-head--2',
    { x: '100%' },
    {
      x: 0,
      duration: 2,
      ease: o,
      scrollTrigger: {
        trigger: '.intro-head',
        start: 'top bottom-=1',
        end: 'bottom top+=1',
        scrub: 1,
        markers: false,
      },
    },
    '-='.concat(2)
  )
  gsap.fromTo(
    '.js-fixSlide',
    {
      y: '80',
      scale: '.65',
    },
    {
      y: '0',
      scale: '1',
      duration: 1,
      ease: o,
      scrollTrigger: {
        trigger: '.js-fixSlide',

        start: '0', // 開始位置
        end: '1000', // 終了位置
        scrub: 1,
        markers: false,
      },
    },
    '-='.concat(2)
  )
  gsap.fromTo(
    '.js-fixCover',
    {
      opacity: '0',
    },
    {
      opacity: '0.82',
      duration: 1,
      ease: o,
      scrollTrigger: {
        trigger: '.js-fixCover',

        start: '500', // 開始位置
        end: '1000', // 終了位置
        scrub: 1,
        markers: false,
      },
    },
    '-='.concat(2)
  )
  gsap.fromTo(
    '.js-topCompany-transform',
    {
      opacity: '1',
    },
    {
      opacity: '0',
      zIndex: -1,
      duration: 1,
      ease: o,
      scrollTrigger: {
        trigger: '.js-topCompany-transform',

        start: 'top',
        end: 'bottom top+=1',
        scrub: 1,
        markers: false,
      },
    },
    '-='.concat(2)
  )
}
